<div class="modal-backdrop" *ngIf="show" (click)="onCancel()"></div>

<div class="modal-container" *ngIf="show" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Choose How to Structure Your Data</h2>
      <button type="button" class="btn-close" (click)="onCancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="workspace-name-section">
        <label for="workspaceName" class="workspace-name-label">
          Workspace Name <span class="optional-text">(optional)</span>
        </label>
        <input 
          type="text" 
          id="workspaceName" 
          class="form-control workspace-name-input" 
          [(ngModel)]="workspaceName"
          placeholder="Leave empty for auto-generated name"
        >
      </div>

      <p class="modal-description">Select how you'd like to structure your uploaded files:</p>

      <div 
        class="option-card" 
        [class.selected]="selectedOption === 'ai'"
        (click)="onOptionSelect('ai')"
      >
        <div class="option-icon-wrapper">
          <img src="../../../assets/img/icons/ai-sparkle.svg" 
               alt="AI indicator" 
               class="option-icon"
               draggable="false">
        </div>
        <div class="option-content">
          <h3 class="option-title">Generate with AI</h3>
          <p class="option-description">Let AI automatically create a structure based on your document content</p>
        </div>
        <div class="option-radio">
          <input 
            type="radio" 
            name="schemaOption" 
            value="ai"
            [checked]="selectedOption === 'ai'"
            (change)="onOptionSelect('ai')"
          >
        </div>
      </div>

      <div 
        class="option-card" 
        [class.selected]="selectedOption === 'manual'"
        (click)="onOptionSelect('manual')"
      >
        <div class="option-icon-wrapper">
          <img src="../../../assets/img/icons/manual-pen.svg" 
               alt="Manual edit indicator" 
               class="option-icon"
               draggable="false">
        </div>
        <div class="option-content">
          <h3 class="option-title">Manual</h3>
          <p class="option-description">Create a custom structure manually from scratch</p>
        </div>
        <div class="option-radio">
          <input 
            type="radio" 
            name="schemaOption" 
            value="manual"
            [checked]="selectedOption === 'manual'"
            (change)="onOptionSelect('manual')"
          >
        </div>
      </div>

      <div 
        #templateCard
        class="option-card" 
        [class.selected]="selectedOption === 'template'"
        [class.disabled]="availableTemplates.length === 0"
        (click)="availableTemplates.length > 0 && onOptionSelect('template')"
      >
        <div class="option-icon-wrapper">
          <img src="../../../assets/img/icons/table-custom.svg" 
               alt="Template icon" 
               class="option-icon"
               draggable="false">
        </div>
        <div class="option-content">
          <h3 class="option-title">Use Saved Template</h3>
          <p class="option-description" *ngIf="availableTemplates.length > 0">
            Apply a previously saved structure template
          </p>
          <p class="option-description text-muted" *ngIf="availableTemplates.length === 0">
            No saved templates available
          </p>
          
          <div class="template-dropdown-wrapper" *ngIf="selectedOption === 'template' && availableTemplates.length > 0">
            <select 
              class="form-select template-select" 
              (change)="onTemplateSelect($event)"
              (click)="$event.stopPropagation()"
            >
              <option value="">Select a template...</option>
              <option 
                *ngFor="let template of availableTemplates" 
                [value]="template.schema_id"
              >
                {{ template.schema_name }}
              </option>
            </select>
          </div>

          <div #schemaPreview class="schema-preview" *ngIf="showPreview" (click)="onPreviewClick($event)">
            <div class="preview-header">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="preview-icon">
                <rect x="2" y="3" width="12" height="10" rx="1" stroke="currentColor" stroke-width="1.5"/>
                <line x1="2" y1="6" x2="14" y2="6" stroke="currentColor" stroke-width="1.5"/>
                <line x1="6" y1="6" x2="6" y2="13" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span class="preview-title">Structure Preview</span>
            </div>

            <div class="preview-tabs" *ngIf="previewSheets.length > 1">
              <button 
                *ngFor="let sheet of previewSheets; let i = index"
                class="preview-tab"
                [class.active]="activePreviewTab === i"
                (click)="onPreviewTabClick(i, $event)"
              >
                {{ sheet.name }}
              </button>
            </div>

            <div class="single-sheet-name" *ngIf="previewSheets.length === 1">
              {{ previewSheets[0].name }}
            </div>

            <div #previewColumns class="preview-columns">
              <div *ngFor="let column of previewSheets[activePreviewTab]?.columns" class="preview-column-card">
                <h6 class="column-name">{{ column.name }}</h6>
                <p class="column-description" *ngIf="column.description">
                  {{ column.description }}
                </p>
                <small class="column-example" *ngIf="column.example">
                  Example: {{ column.example }}
                </small>
              </div>
              <div *ngIf="!previewSheets[activePreviewTab]?.columns?.length" class="no-columns">
                No columns defined
              </div>
            </div>
          </div>
        </div>
        <div class="option-radio">
          <input 
            type="radio" 
            name="schemaOption" 
            value="template"
            [checked]="selectedOption === 'template'"
            [disabled]="availableTemplates.length === 0"
            (change)="onOptionSelect('template')"
          >
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button 
        type="button" 
        class="btn btn-secondary" 
        (click)="onCancel()"
      >
        Cancel
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="onContinue()"
        [disabled]="selectedOption === 'template' && !selectedTemplateId"
      >
        Continue
      </button>
    </div>
  </div>
</div>

